import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';

import SunshineCard from 'components/_core/SunshineCard';

import { InvoicePresetsFormSchema } from '../../invoicePresetsForm.schema';
import locales from './locales';

interface TradeNameCardProps {
  control: Control<InvoicePresetsFormSchema>;
  onCheckChange: () => void;
}

export const TradeNameCard: FC<TradeNameCardProps> = ({
  control,
  onCheckChange,
}) => (
  <SunshineCard.Group>
    <Controller
      control={control}
      name="displayTradeName"
      render={({ field }) => (
        <SunshineCard
          isChecked={field.value ?? false}
          onChange={(e) => {
            field.onChange(e.target.checked);
            onCheckChange();
          }}
          title={locales.label}
          variant="checkbox"
        />
      )}
    />
  </SunshineCard.Group>
);
